import SignInVue from "@/pages/auth/SignIn.vue";

const router = [
  {
    path: "/sign-in",
    name: "sign-in",
    component: SignInVue,
    meta: {
      layout: "AppAuthLayout",
      parent: "Authentication",
      name: "login",
      requiresAuth: false
    },
  },



];

export default router;
